import { Component, OnInit, SecurityContext } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ListaEmpresasService } from 'src/app/Services/lista-empresas.service';
import { DetalleUsuarioService } from 'src/app/Services/detalle-usuario.service';

@Component({
  selector: 'app-headerlog',
  templateUrl: './headerlog.component.html',
  styleUrls: ['./headerlog.component.css']
})
export class HeaderlogComponent implements OnInit {
  menuItems: { destination: string, description: string }[] = [
    { destination: '/primer', description: 'Inicio' }
  ];
  
  
  private represent:string = environment.represent;
  rut: string;
  result:any;
  code:string;
  state:string;
  cantEmpresaRep:number;

  constructor(private http: HttpClient,
      private router: Router,
      private sanitizer:DomSanitizer,
      public listaEmprService: ListaEmpresasService,
      public detalleUsuarioService: DetalleUsuarioService) {
    let httpost = this.http;
    let urlrep = `${ this.represent}`;
    let primerRegistro = true;
    //console.log(urltoken);


    if ( (this.code == null || this.code == 'undefined') && localStorage.getItem('code') != null ) { 
      this.code = localStorage.getItem('code');
    }
  
    if ( (this.state == null || this.state == 'undefined') && localStorage.getItem('state') != null ) { 
      this.state = localStorage.getItem('state');
    }

    this.detalleUsuarioService.getVariableCompartida().subscribe(datos => {
      //console.log(datos);
      this.rut = datos;
    });
    
    if (this.rut=="0"||this.rut==null) {
      this.cerrar();
      return;
    }
    
    /*httpost.post<any>(urlrep, { 
      rut_repres_legal:this.rut
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      //console.log(response);
      //console.log(status);
      const data = response.body;
      if (status===202) { 
        this.router.navigate(['/rut-empresa-form']);
      }else if (status===200){
        this.cantEmpresaRep=data.totalRecords;
        this.listaEmprService.guardarEmpresas(data.Consulta);

        this.listaEmprService.obtenerEmpresas().forEach((item) => {
          if (primerRegistro){
            if (this.listaEmprService.obtenerEmpresaSel() == null || this.listaEmprService.obtenerEmpresaSel() == undefined) {
              this.listaEmprService.seleccionarEmpresa(item.RUT_EMPRESA,item.RAZON_SOCIAL);
            }
          }
          console.log('RUT_EMPRESA:', item.RUT_EMPRESA);
          console.log('ESTADO_REPRESENTANTE_EMPRESA:', item.ESTADO_REPRESENTANTE_EMPRESA);
          console.log('RAZON_SOCIAL:', item.RAZON_SOCIAL);
          primerRegistro=false;
        });
      }else{
        console.log("error capturado.");
      };
      
    }, err => {
      console.log("error capturado");
      console.log(err);
    });*/
  }

  ngOnInit(): void {
  }

  cerrar(){
    //var urlcierre :string="https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout?https%3A%2F%2Faplicaciones.mop.gob.cl%2FTramitesDCyF";
    //var sanitizedValue:string= this.sanitizer.sanitize(SecurityContext.URL,urlcierre);
    //window.location.href=sanitizedValue;
    this.listaEmprService.limpiarDatos();
    this.detalleUsuarioService.limpiarDatos();
    this.detalleUsuarioService.limpiarRut();
    this.detalleUsuarioService.limpiarFuncionalidadesJson();
    localStorage.clear();
    this.router.navigate(['/inicio']);
  }
}
